import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _77083efa = () => interopDefault(import('../pages/interest.vue' /* webpackChunkName: "pages/interest" */))
const _57062649 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _23ef8f09 = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _821ea770 = () => interopDefault(import('../pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _762f3366 = () => interopDefault(import('../pages/radar.vue' /* webpackChunkName: "pages/radar" */))
const _14af8948 = () => interopDefault(import('../pages/radar/_city/_slug.vue' /* webpackChunkName: "pages/radar/_city/_slug" */))
const _da250dd2 = () => interopDefault(import('../pages/orp-landing.vue' /* webpackChunkName: "pages/orp-landing" */))
const _16a10058 = () => interopDefault(import('../pages/preferences.vue' /* webpackChunkName: "pages/preferences" */))
const _53cee030 = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _43b70ee4 = () => interopDefault(import('../pages/suggest.vue' /* webpackChunkName: "pages/suggest" */))
const _d6d52c5c = () => interopDefault(import('../pages/suggest/_id/index.vue' /* webpackChunkName: "pages/suggest/_id/index" */))
const _9334db02 = () => interopDefault(import('../pages/auth/apple-callback.vue' /* webpackChunkName: "pages/auth/apple-callback" */))
const _8addc1d6 = () => interopDefault(import('../pages/auth/facebook-callback.vue' /* webpackChunkName: "pages/auth/facebook-callback" */))
const _ffbdf846 = () => interopDefault(import('../pages/auth/linkedin-callback.vue' /* webpackChunkName: "pages/auth/linkedin-callback" */))
const _3ffcc5c7 = () => interopDefault(import('../pages/user/settings.vue' /* webpackChunkName: "pages/user/settings" */))
const _03bea19b = () => interopDefault(import('../pages/user/settings/applications.vue' /* webpackChunkName: "pages/user/settings/applications" */))
const _181ba96c = () => interopDefault(import('../pages/user/settings/my-cv.vue' /* webpackChunkName: "pages/user/settings/my-cv" */))
const _1d177254 = () => interopDefault(import('../pages/user/settings/my-referral.vue' /* webpackChunkName: "pages/user/settings/my-referral" */))
const _2b9f7423 = () => interopDefault(import('../pages/user/settings/my-referral-redeem.vue' /* webpackChunkName: "pages/user/settings/my-referral-redeem" */))
const _10bb27c0 = () => interopDefault(import('../pages/user/settings/notifications.vue' /* webpackChunkName: "pages/user/settings/notifications" */))
const _771a53ee = () => interopDefault(import('../pages/user/settings/personality-test.vue' /* webpackChunkName: "pages/user/settings/personality-test" */))
const _8a51df3e = () => interopDefault(import('../pages/user/settings/profile.vue' /* webpackChunkName: "pages/user/settings/profile" */))
const _ec366590 = () => interopDefault(import('../pages/user/settings/security.vue' /* webpackChunkName: "pages/user/settings/security" */))
const _15b2c1da = () => interopDefault(import('../pages/user/settings/update-cv/_id.vue' /* webpackChunkName: "pages/user/settings/update-cv/_id" */))
const _5ab2b694 = () => interopDefault(import('../pages/user/test.vue' /* webpackChunkName: "pages/user/test" */))
const _3e016bc4 = () => interopDefault(import('../pages/auth/google/callback.vue' /* webpackChunkName: "pages/auth/google/callback" */))
const _98cb0eac = () => interopDefault(import('../pages/user/results/test/_slug.vue' /* webpackChunkName: "pages/user/results/test/_slug" */))
const _2a577e6a = () => interopDefault(import('../pages/all/_wp.vue' /* webpackChunkName: "pages/all/_wp" */))
const _18bb72c4 = () => interopDefault(import('../pages/application/_id/index.vue' /* webpackChunkName: "pages/application/_id/index" */))
const _77dcc5cd = () => interopDefault(import('../pages/application/_id/interview.vue' /* webpackChunkName: "pages/application/_id/interview" */))
const _74fabe73 = () => interopDefault(import('../pages/application/_id/steps.vue' /* webpackChunkName: "pages/application/_id/steps" */))
const _386371e2 = () => interopDefault(import('../pages/application/_id/typeform.vue' /* webpackChunkName: "pages/application/_id/typeform" */))
const _32d31600 = () => interopDefault(import('../pages/application/_id/candidate/confirm.vue' /* webpackChunkName: "pages/application/_id/candidate/confirm" */))
const _19c4ee0f = () => interopDefault(import('../pages/application/_id/candidate/reject.vue' /* webpackChunkName: "pages/application/_id/candidate/reject" */))
const _667293c2 = () => interopDefault(import('../pages/dtw/_slug.vue' /* webpackChunkName: "pages/dtw/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de",
    component: _e542f99c,
    name: "index___de"
  }, {
    path: "/en",
    component: _e542f99c,
    name: "index___en"
  }, {
    path: "/es",
    component: _e542f99c,
    name: "index___es"
  }, {
    path: "/fr",
    component: _e542f99c,
    name: "index___fr"
  }, {
    path: "/interest",
    component: _77083efa,
    name: "interest___it"
  }, {
    path: "/login",
    component: _57062649,
    name: "login___it"
  }, {
    path: "/newsletter",
    component: _23ef8f09,
    name: "newsletter___it"
  }, {
    path: "/notifications",
    component: _821ea770,
    name: "notifications___it"
  }, {
    path: "/offerte-lavoro",
    component: _762f3366,
    name: "radar___it",
    children: [{
      path: "/offerte-lavoro/:city/:slug",
      component: _14af8948,
      name: "radar-city-slug___it"
    }]
  }, {
    path: "/orp-landing",
    component: _da250dd2,
    name: "orp-landing___it"
  }, {
    path: "/preferences",
    component: _16a10058,
    name: "preferences___it"
  }, {
    path: "/pt",
    component: _e542f99c,
    name: "index___pt"
  }, {
    path: "/signup",
    component: _53cee030,
    name: "signup___it"
  }, {
    path: "/suggest",
    component: _43b70ee4,
    name: "suggest___it",
    children: [{
      path: ":id",
      component: _d6d52c5c,
      name: "suggest-id___it"
    }]
  }, {
    path: "/auth/apple-callback",
    component: _9334db02,
    name: "auth-apple-callback___it"
  }, {
    path: "/auth/facebook-callback",
    component: _8addc1d6,
    name: "auth-facebook-callback___it"
  }, {
    path: "/auth/linkedin-callback",
    component: _ffbdf846,
    name: "auth-linkedin-callback___it"
  }, {
    path: "/de/interest",
    component: _77083efa,
    name: "interest___de"
  }, {
    path: "/de/job-angebote",
    component: _762f3366,
    name: "radar___de",
    children: [{
      path: "/de/job-angebote/:city/:slug",
      component: _14af8948,
      name: "radar-city-slug___de"
    }]
  }, {
    path: "/de/login",
    component: _57062649,
    name: "login___de"
  }, {
    path: "/de/newsletter",
    component: _23ef8f09,
    name: "newsletter___de"
  }, {
    path: "/de/notifications",
    component: _821ea770,
    name: "notifications___de"
  }, {
    path: "/de/orp-landing",
    component: _da250dd2,
    name: "orp-landing___de"
  }, {
    path: "/de/preferences",
    component: _16a10058,
    name: "preferences___de"
  }, {
    path: "/de/signup",
    component: _53cee030,
    name: "signup___de"
  }, {
    path: "/de/suggest",
    component: _43b70ee4,
    name: "suggest___de",
    children: [{
      path: ":id",
      component: _d6d52c5c,
      name: "suggest-id___de"
    }]
  }, {
    path: "/en/interest",
    component: _77083efa,
    name: "interest___en"
  }, {
    path: "/en/job-offers",
    component: _762f3366,
    name: "radar___en",
    children: [{
      path: "/en/job-offers/:city/:slug",
      component: _14af8948,
      name: "radar-city-slug___en"
    }]
  }, {
    path: "/en/login",
    component: _57062649,
    name: "login___en"
  }, {
    path: "/en/newsletter",
    component: _23ef8f09,
    name: "newsletter___en"
  }, {
    path: "/en/notifications",
    component: _821ea770,
    name: "notifications___en"
  }, {
    path: "/en/orp-landing",
    component: _da250dd2,
    name: "orp-landing___en"
  }, {
    path: "/en/preferences",
    component: _16a10058,
    name: "preferences___en"
  }, {
    path: "/en/signup",
    component: _53cee030,
    name: "signup___en"
  }, {
    path: "/en/suggest",
    component: _43b70ee4,
    name: "suggest___en",
    children: [{
      path: ":id",
      component: _d6d52c5c,
      name: "suggest-id___en"
    }]
  }, {
    path: "/es/interest",
    component: _77083efa,
    name: "interest___es"
  }, {
    path: "/es/login",
    component: _57062649,
    name: "login___es"
  }, {
    path: "/es/newsletter",
    component: _23ef8f09,
    name: "newsletter___es"
  }, {
    path: "/es/notifications",
    component: _821ea770,
    name: "notifications___es"
  }, {
    path: "/es/ofertas-empleo",
    component: _762f3366,
    name: "radar___es",
    children: [{
      path: "/es/ofertas-empleo/:city/:slug",
      component: _14af8948,
      name: "radar-city-slug___es"
    }]
  }, {
    path: "/es/orp-landing",
    component: _da250dd2,
    name: "orp-landing___es"
  }, {
    path: "/es/preferences",
    component: _16a10058,
    name: "preferences___es"
  }, {
    path: "/es/signup",
    component: _53cee030,
    name: "signup___es"
  }, {
    path: "/es/suggest",
    component: _43b70ee4,
    name: "suggest___es",
    children: [{
      path: ":id",
      component: _d6d52c5c,
      name: "suggest-id___es"
    }]
  }, {
    path: "/fr/interest",
    component: _77083efa,
    name: "interest___fr"
  }, {
    path: "/fr/login",
    component: _57062649,
    name: "login___fr"
  }, {
    path: "/fr/newsletter",
    component: _23ef8f09,
    name: "newsletter___fr"
  }, {
    path: "/fr/notifications",
    component: _821ea770,
    name: "notifications___fr"
  }, {
    path: "/fr/offres-emploi",
    component: _762f3366,
    name: "radar___fr",
    children: [{
      path: "/fr/offres-emploi/:city/:slug",
      component: _14af8948,
      name: "radar-city-slug___fr"
    }]
  }, {
    path: "/fr/orp-landing",
    component: _da250dd2,
    name: "orp-landing___fr"
  }, {
    path: "/fr/preferences",
    component: _16a10058,
    name: "preferences___fr"
  }, {
    path: "/fr/signup",
    component: _53cee030,
    name: "signup___fr"
  }, {
    path: "/fr/suggest",
    component: _43b70ee4,
    name: "suggest___fr",
    children: [{
      path: ":id",
      component: _d6d52c5c,
      name: "suggest-id___fr"
    }]
  }, {
    path: "/pt/interest",
    component: _77083efa,
    name: "interest___pt"
  }, {
    path: "/pt/login",
    component: _57062649,
    name: "login___pt"
  }, {
    path: "/pt/newsletter",
    component: _23ef8f09,
    name: "newsletter___pt"
  }, {
    path: "/pt/notifications",
    component: _821ea770,
    name: "notifications___pt"
  }, {
    path: "/pt/ofertas-emprego",
    component: _762f3366,
    name: "radar___pt",
    children: [{
      path: "/pt/ofertas-emprego/:city/:slug",
      component: _14af8948,
      name: "radar-city-slug___pt"
    }]
  }, {
    path: "/pt/orp-landing",
    component: _da250dd2,
    name: "orp-landing___pt"
  }, {
    path: "/pt/preferences",
    component: _16a10058,
    name: "preferences___pt"
  }, {
    path: "/pt/signup",
    component: _53cee030,
    name: "signup___pt"
  }, {
    path: "/pt/suggest",
    component: _43b70ee4,
    name: "suggest___pt",
    children: [{
      path: ":id",
      component: _d6d52c5c,
      name: "suggest-id___pt"
    }]
  }, {
    path: "/user/settings",
    component: _3ffcc5c7,
    name: "user-settings___it",
    children: [{
      path: "applications",
      component: _03bea19b,
      name: "user-settings-applications___it"
    }, {
      path: "my-cv",
      component: _181ba96c,
      name: "user-settings-my-cv___it"
    }, {
      path: "my-referral",
      component: _1d177254,
      name: "user-settings-my-referral___it"
    }, {
      path: "my-referral-redeem",
      component: _2b9f7423,
      name: "user-settings-my-referral-redeem___it"
    }, {
      path: "notifications",
      component: _10bb27c0,
      name: "user-settings-notifications___it"
    }, {
      path: "personality-test",
      component: _771a53ee,
      name: "user-settings-personality-test___it"
    }, {
      path: "profile",
      component: _8a51df3e,
      name: "user-settings-profile___it"
    }, {
      path: "security",
      component: _ec366590,
      name: "user-settings-security___it"
    }, {
      path: "update-cv/:id?",
      component: _15b2c1da,
      name: "user-settings-update-cv-id___it"
    }]
  }, {
    path: "/user/test",
    component: _5ab2b694,
    name: "user-test___it"
  }, {
    path: "/auth/google/callback",
    component: _3e016bc4,
    name: "auth-google-callback___it"
  }, {
    path: "/de/auth/apple-callback",
    component: _9334db02,
    name: "auth-apple-callback___de"
  }, {
    path: "/de/auth/facebook-callback",
    component: _8addc1d6,
    name: "auth-facebook-callback___de"
  }, {
    path: "/de/auth/linkedin-callback",
    component: _ffbdf846,
    name: "auth-linkedin-callback___de"
  }, {
    path: "/de/user/settings",
    component: _3ffcc5c7,
    name: "user-settings___de",
    children: [{
      path: "applications",
      component: _03bea19b,
      name: "user-settings-applications___de"
    }, {
      path: "my-cv",
      component: _181ba96c,
      name: "user-settings-my-cv___de"
    }, {
      path: "my-referral",
      component: _1d177254,
      name: "user-settings-my-referral___de"
    }, {
      path: "my-referral-redeem",
      component: _2b9f7423,
      name: "user-settings-my-referral-redeem___de"
    }, {
      path: "notifications",
      component: _10bb27c0,
      name: "user-settings-notifications___de"
    }, {
      path: "personality-test",
      component: _771a53ee,
      name: "user-settings-personality-test___de"
    }, {
      path: "profile",
      component: _8a51df3e,
      name: "user-settings-profile___de"
    }, {
      path: "security",
      component: _ec366590,
      name: "user-settings-security___de"
    }, {
      path: "update-cv/:id?",
      component: _15b2c1da,
      name: "user-settings-update-cv-id___de"
    }]
  }, {
    path: "/de/user/test",
    component: _5ab2b694,
    name: "user-test___de"
  }, {
    path: "/en/auth/apple-callback",
    component: _9334db02,
    name: "auth-apple-callback___en"
  }, {
    path: "/en/auth/facebook-callback",
    component: _8addc1d6,
    name: "auth-facebook-callback___en"
  }, {
    path: "/en/auth/linkedin-callback",
    component: _ffbdf846,
    name: "auth-linkedin-callback___en"
  }, {
    path: "/en/user/settings",
    component: _3ffcc5c7,
    name: "user-settings___en",
    children: [{
      path: "applications",
      component: _03bea19b,
      name: "user-settings-applications___en"
    }, {
      path: "my-cv",
      component: _181ba96c,
      name: "user-settings-my-cv___en"
    }, {
      path: "my-referral",
      component: _1d177254,
      name: "user-settings-my-referral___en"
    }, {
      path: "my-referral-redeem",
      component: _2b9f7423,
      name: "user-settings-my-referral-redeem___en"
    }, {
      path: "notifications",
      component: _10bb27c0,
      name: "user-settings-notifications___en"
    }, {
      path: "personality-test",
      component: _771a53ee,
      name: "user-settings-personality-test___en"
    }, {
      path: "profile",
      component: _8a51df3e,
      name: "user-settings-profile___en"
    }, {
      path: "security",
      component: _ec366590,
      name: "user-settings-security___en"
    }, {
      path: "update-cv/:id?",
      component: _15b2c1da,
      name: "user-settings-update-cv-id___en"
    }]
  }, {
    path: "/en/user/test",
    component: _5ab2b694,
    name: "user-test___en"
  }, {
    path: "/es/auth/apple-callback",
    component: _9334db02,
    name: "auth-apple-callback___es"
  }, {
    path: "/es/auth/facebook-callback",
    component: _8addc1d6,
    name: "auth-facebook-callback___es"
  }, {
    path: "/es/auth/linkedin-callback",
    component: _ffbdf846,
    name: "auth-linkedin-callback___es"
  }, {
    path: "/es/user/settings",
    component: _3ffcc5c7,
    name: "user-settings___es",
    children: [{
      path: "applications",
      component: _03bea19b,
      name: "user-settings-applications___es"
    }, {
      path: "my-cv",
      component: _181ba96c,
      name: "user-settings-my-cv___es"
    }, {
      path: "my-referral",
      component: _1d177254,
      name: "user-settings-my-referral___es"
    }, {
      path: "my-referral-redeem",
      component: _2b9f7423,
      name: "user-settings-my-referral-redeem___es"
    }, {
      path: "notifications",
      component: _10bb27c0,
      name: "user-settings-notifications___es"
    }, {
      path: "personality-test",
      component: _771a53ee,
      name: "user-settings-personality-test___es"
    }, {
      path: "profile",
      component: _8a51df3e,
      name: "user-settings-profile___es"
    }, {
      path: "security",
      component: _ec366590,
      name: "user-settings-security___es"
    }, {
      path: "update-cv/:id?",
      component: _15b2c1da,
      name: "user-settings-update-cv-id___es"
    }]
  }, {
    path: "/es/user/test",
    component: _5ab2b694,
    name: "user-test___es"
  }, {
    path: "/fr/auth/apple-callback",
    component: _9334db02,
    name: "auth-apple-callback___fr"
  }, {
    path: "/fr/auth/facebook-callback",
    component: _8addc1d6,
    name: "auth-facebook-callback___fr"
  }, {
    path: "/fr/auth/linkedin-callback",
    component: _ffbdf846,
    name: "auth-linkedin-callback___fr"
  }, {
    path: "/fr/user/settings",
    component: _3ffcc5c7,
    name: "user-settings___fr",
    children: [{
      path: "applications",
      component: _03bea19b,
      name: "user-settings-applications___fr"
    }, {
      path: "my-cv",
      component: _181ba96c,
      name: "user-settings-my-cv___fr"
    }, {
      path: "my-referral",
      component: _1d177254,
      name: "user-settings-my-referral___fr"
    }, {
      path: "my-referral-redeem",
      component: _2b9f7423,
      name: "user-settings-my-referral-redeem___fr"
    }, {
      path: "notifications",
      component: _10bb27c0,
      name: "user-settings-notifications___fr"
    }, {
      path: "personality-test",
      component: _771a53ee,
      name: "user-settings-personality-test___fr"
    }, {
      path: "profile",
      component: _8a51df3e,
      name: "user-settings-profile___fr"
    }, {
      path: "security",
      component: _ec366590,
      name: "user-settings-security___fr"
    }, {
      path: "update-cv/:id?",
      component: _15b2c1da,
      name: "user-settings-update-cv-id___fr"
    }]
  }, {
    path: "/fr/user/test",
    component: _5ab2b694,
    name: "user-test___fr"
  }, {
    path: "/pt/auth/apple-callback",
    component: _9334db02,
    name: "auth-apple-callback___pt"
  }, {
    path: "/pt/auth/facebook-callback",
    component: _8addc1d6,
    name: "auth-facebook-callback___pt"
  }, {
    path: "/pt/auth/linkedin-callback",
    component: _ffbdf846,
    name: "auth-linkedin-callback___pt"
  }, {
    path: "/pt/user/settings",
    component: _3ffcc5c7,
    name: "user-settings___pt",
    children: [{
      path: "applications",
      component: _03bea19b,
      name: "user-settings-applications___pt"
    }, {
      path: "my-cv",
      component: _181ba96c,
      name: "user-settings-my-cv___pt"
    }, {
      path: "my-referral",
      component: _1d177254,
      name: "user-settings-my-referral___pt"
    }, {
      path: "my-referral-redeem",
      component: _2b9f7423,
      name: "user-settings-my-referral-redeem___pt"
    }, {
      path: "notifications",
      component: _10bb27c0,
      name: "user-settings-notifications___pt"
    }, {
      path: "personality-test",
      component: _771a53ee,
      name: "user-settings-personality-test___pt"
    }, {
      path: "profile",
      component: _8a51df3e,
      name: "user-settings-profile___pt"
    }, {
      path: "security",
      component: _ec366590,
      name: "user-settings-security___pt"
    }, {
      path: "update-cv/:id?",
      component: _15b2c1da,
      name: "user-settings-update-cv-id___pt"
    }]
  }, {
    path: "/pt/user/test",
    component: _5ab2b694,
    name: "user-test___pt"
  }, {
    path: "/de/auth/google/callback",
    component: _3e016bc4,
    name: "auth-google-callback___de"
  }, {
    path: "/en/auth/google/callback",
    component: _3e016bc4,
    name: "auth-google-callback___en"
  }, {
    path: "/es/auth/google/callback",
    component: _3e016bc4,
    name: "auth-google-callback___es"
  }, {
    path: "/fr/auth/google/callback",
    component: _3e016bc4,
    name: "auth-google-callback___fr"
  }, {
    path: "/pt/auth/google/callback",
    component: _3e016bc4,
    name: "auth-google-callback___pt"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index___it"
  }, {
    path: "/de/user/results/test/:slug?",
    component: _98cb0eac,
    name: "user-results-test-slug___de"
  }, {
    path: "/en/user/results/test/:slug?",
    component: _98cb0eac,
    name: "user-results-test-slug___en"
  }, {
    path: "/es/user/results/test/:slug?",
    component: _98cb0eac,
    name: "user-results-test-slug___es"
  }, {
    path: "/fr/user/results/test/:slug?",
    component: _98cb0eac,
    name: "user-results-test-slug___fr"
  }, {
    path: "/pt/user/results/test/:slug?",
    component: _98cb0eac,
    name: "user-results-test-slug___pt"
  }, {
    path: "/user/results/test/:slug?",
    component: _98cb0eac,
    name: "user-results-test-slug___it"
  }, {
    path: "/de/all/:wp?",
    component: _2a577e6a,
    name: "all-wp___de"
  }, {
    path: "/de/application/:id",
    component: _18bb72c4,
    name: "application-id___de"
  }, {
    path: "/de/job-angebote/:city",
    component: _762f3366,
    name: "radar-city___de"
  }, {
    path: "/en/all/:wp?",
    component: _2a577e6a,
    name: "all-wp___en"
  }, {
    path: "/en/application/:id",
    component: _18bb72c4,
    name: "application-id___en"
  }, {
    path: "/en/job-offers/:city",
    component: _762f3366,
    name: "radar-city___en"
  }, {
    path: "/es/all/:wp?",
    component: _2a577e6a,
    name: "all-wp___es"
  }, {
    path: "/es/application/:id",
    component: _18bb72c4,
    name: "application-id___es"
  }, {
    path: "/es/ofertas-empleo/:city",
    component: _762f3366,
    name: "radar-city___es"
  }, {
    path: "/fr/all/:wp?",
    component: _2a577e6a,
    name: "all-wp___fr"
  }, {
    path: "/fr/application/:id",
    component: _18bb72c4,
    name: "application-id___fr"
  }, {
    path: "/fr/offres-emploi/:city",
    component: _762f3366,
    name: "radar-city___fr"
  }, {
    path: "/pt/all/:wp?",
    component: _2a577e6a,
    name: "all-wp___pt"
  }, {
    path: "/pt/application/:id",
    component: _18bb72c4,
    name: "application-id___pt"
  }, {
    path: "/pt/ofertas-emprego/:city",
    component: _762f3366,
    name: "radar-city___pt"
  }, {
    path: "/de/application/:id?/interview",
    component: _77dcc5cd,
    name: "application-id-interview___de"
  }, {
    path: "/de/application/:id?/steps",
    component: _74fabe73,
    name: "application-id-steps___de"
  }, {
    path: "/de/application/:id?/typeform",
    component: _386371e2,
    name: "application-id-typeform___de"
  }, {
    path: "/en/application/:id?/interview",
    component: _77dcc5cd,
    name: "application-id-interview___en"
  }, {
    path: "/en/application/:id?/steps",
    component: _74fabe73,
    name: "application-id-steps___en"
  }, {
    path: "/en/application/:id?/typeform",
    component: _386371e2,
    name: "application-id-typeform___en"
  }, {
    path: "/es/application/:id?/interview",
    component: _77dcc5cd,
    name: "application-id-interview___es"
  }, {
    path: "/es/application/:id?/steps",
    component: _74fabe73,
    name: "application-id-steps___es"
  }, {
    path: "/es/application/:id?/typeform",
    component: _386371e2,
    name: "application-id-typeform___es"
  }, {
    path: "/fr/application/:id?/interview",
    component: _77dcc5cd,
    name: "application-id-interview___fr"
  }, {
    path: "/fr/application/:id?/steps",
    component: _74fabe73,
    name: "application-id-steps___fr"
  }, {
    path: "/fr/application/:id?/typeform",
    component: _386371e2,
    name: "application-id-typeform___fr"
  }, {
    path: "/pt/application/:id?/interview",
    component: _77dcc5cd,
    name: "application-id-interview___pt"
  }, {
    path: "/pt/application/:id?/steps",
    component: _74fabe73,
    name: "application-id-steps___pt"
  }, {
    path: "/pt/application/:id?/typeform",
    component: _386371e2,
    name: "application-id-typeform___pt"
  }, {
    path: "/de/application/:id?/candidate/confirm",
    component: _32d31600,
    name: "application-id-candidate-confirm___de"
  }, {
    path: "/de/application/:id?/candidate/reject",
    component: _19c4ee0f,
    name: "application-id-candidate-reject___de"
  }, {
    path: "/en/application/:id?/candidate/confirm",
    component: _32d31600,
    name: "application-id-candidate-confirm___en"
  }, {
    path: "/en/application/:id?/candidate/reject",
    component: _19c4ee0f,
    name: "application-id-candidate-reject___en"
  }, {
    path: "/es/application/:id?/candidate/confirm",
    component: _32d31600,
    name: "application-id-candidate-confirm___es"
  }, {
    path: "/es/application/:id?/candidate/reject",
    component: _19c4ee0f,
    name: "application-id-candidate-reject___es"
  }, {
    path: "/fr/application/:id?/candidate/confirm",
    component: _32d31600,
    name: "application-id-candidate-confirm___fr"
  }, {
    path: "/fr/application/:id?/candidate/reject",
    component: _19c4ee0f,
    name: "application-id-candidate-reject___fr"
  }, {
    path: "/pt/application/:id?/candidate/confirm",
    component: _32d31600,
    name: "application-id-candidate-confirm___pt"
  }, {
    path: "/pt/application/:id?/candidate/reject",
    component: _19c4ee0f,
    name: "application-id-candidate-reject___pt"
  }, {
    path: "/all/:wp?",
    component: _2a577e6a,
    name: "all-wp___it"
  }, {
    path: "/application/:id",
    component: _18bb72c4,
    name: "application-id___it"
  }, {
    path: "/dtw/:slug?",
    component: _667293c2,
    name: "dtw-slug___it"
  }, {
    path: "/offerte-lavoro/:city",
    component: _762f3366,
    name: "radar-city___it"
  }, {
    path: "/application/:id?/interview",
    component: _77dcc5cd,
    name: "application-id-interview___it"
  }, {
    path: "/application/:id?/steps",
    component: _74fabe73,
    name: "application-id-steps___it"
  }, {
    path: "/application/:id?/typeform",
    component: _386371e2,
    name: "application-id-typeform___it"
  }, {
    path: "/application/:id?/candidate/confirm",
    component: _32d31600,
    name: "application-id-candidate-confirm___it"
  }, {
    path: "/application/:id?/candidate/reject",
    component: _19c4ee0f,
    name: "application-id-candidate-reject___it"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
